import { render, staticRenderFns } from "./LazyLoadedImage.vue?vue&type=template&id=4bf4e190&scoped=true"
import script from "./LazyLoadedImage.vue?vue&type=script&lang=js"
export * from "./LazyLoadedImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf4e190",
  null
  
)

export default component.exports